$(document).ready(function(){
    $(".step__el").css('opacity','0');
    $(".step__el").css('top','-50px');

    var windowHeight = window.innerHeight; // taille de l'ecran
    var durationInterval = 200;
    
    var firstBoxAnimated = $('.step__el:nth-child(1)');
    var secondBoxAnimated = $('.step__el:nth-child(2)');
    var thirdBoxAnimated = $('.step__el:nth-child(3)');
    var fourthBoxAnimated = $('.step__el:nth-child(4)');
    
    // h -> height
    // sp -> scroll position  
    var h_animatedBox = $(firstBoxAnimated).height();
    var sp_animatedBox = $(firstBoxAnimated).offset().top + h_animatedBox + 300;
      
    $(window).scroll(function(){
        var scrollCurrent = $(this).scrollTop();// taille du scroll - top de la page et top de l'Ã©cran
        //console.log('current scroll : '+scrollCurrent);

        //animation des boxes au scroll
        if (scrollCurrent > sp_animatedBox - windowHeight - h_animatedBox) {
            // console.log('animated');
            anim(firstBoxAnimated);
            
            setTimeout(() => {
                anim(secondBoxAnimated);
                
                setTimeout(() => {
                    anim(thirdBoxAnimated);

                    setTimeout(() => {
                        anim(fourthBoxAnimated);
                    }, durationInterval);

                }, durationInterval);
                
            }, durationInterval);
        }
    });
  
    function anim(el){
        $(el).animate({
            top : '0px',
            opacity : '1',
        }, 1000);
    }

  });

//TRANSITION DE PAGE
const link = document.querySelectorAll('.btn');
const page = document.querySelector('.rond');
const section = document.querySelector('.section--animation');

link.forEach((element) =>{

    element.addEventListener('click', (e) => {

        const currentLink = element.href;

        section.classList.remove('hide');

        document.body.classList.add('animation');

        page.addEventListener('animationend', function(){
            window.location = currentLink;  
        });

        e.preventDefault();
    });

});